// tipo-entidad.service.ts

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface TipoEntidad {
  identifier: string;
  name: string;
  type: string;
  menu: string;
}

@Injectable({
  providedIn: 'root'
})
export class TipoEntidadService {

  constructor(private http: HttpClient) {}

  getTipos(): Observable<TipoEntidad[]> {
    return this.http.get<TipoEntidad[]>('assets/jsondata/tipoEntidad.json');
  }
}
